const BlockContact = () => {
  let $component

  const self = {
    init() {
      self.addEventListeners()
    },
    onLoad() {
      jQuery('#contactbutton').click(function () {
        jQuery.ajax({
          type: 'POST',
          url: ajax_object.ajax_url,
          data: jQuery('#contactform').serialize(),
          dataType: 'json',
          success: function (response) {
            if (response.status == 'success') {
              jQuery('#contactform').hide()
            }
            jQuery('#contact-msg').addClass('active');
            jQuery('#contact-msg').html(response.errmessage)
          }
        })

      })
    },
    addEventListeners() {
      self.onLoad()
    }
  }

  return self
}

export default BlockContact